import { Component, Input, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { UserLogin } from 'src/app/models/user-login.model';
import { AuthService } from 'src/app/services/auth.service';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { EventsService } from 'src/app/services/events.service';
import { Utilities } from 'src/app/services/utilities';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styles: [],
})
export class LoginComponent implements OnInit {
    constructor(private authService: AuthService, private configurations: ConfigurationService, private eventsService: EventsService) {}

    userLogin = new UserLogin();

    isLoading = false;

    formResetToggle = true;

    modalClosedCallback: () => void;

    loginStatusSubscription: any;

    @Input()
    isModal = false;

    loginError: boolean;

    ngOnInit(): void {
        this.userLogin.rememberMe = this.authService.rememberMe;

        if (this.getShouldRedirect()) {
            this.authService.redirectLoginUser();
        } else {
            this.loginStatusSubscription = this.authService.getLoginStatusEvent().subscribe((isLoggedIn) => {
                if (this.getShouldRedirect()) {
                    this.authService.redirectLoginUser();
                }
            });
        }
    }

    ngOnDestroy(): void {
        if (this.loginStatusSubscription) {
            this.loginStatusSubscription.unsubscribe();
        }
    }

    getShouldRedirect() {
        return !this.isModal && this.authService.isLoggedIn && !this.authService.isSessionExpired;
    }

    showErrorAlert(caption: string, message: string) {}

    closeModal() {
        if (this.modalClosedCallback) {
            this.modalClosedCallback();
        }
        this.eventsService.trigger.next({ name: 'closeLoginModal', value: null });
    }

    login(form: NgForm) {
        this.isLoading = true;
        this.loginError = false;
        this.authService.loginWithPassword(this.userLogin.userName, this.userLogin.password, this.userLogin.rememberMe).subscribe(
            (user) => {
                setTimeout(() => {
                    this.isLoading = false;

                    this.reset();

                    if (!this.isModal) {
                    } else {
                        setTimeout(() => {}, 500);
                        this.closeModal();
                    }
                });
            },
            (error) => {
                if (Utilities.checkNoNetwork(error)) {
                    this.offerAlternateHost();
                } else {
                    const errorMessage = Utilities.getHttpResponseMessage(error);

                    if (errorMessage === 'invalid_username_or_password' || 'invalid_grant') {
                        this.loginError = true;
                    }
                }

                setTimeout(() => {
                    this.isLoading = false;
                });
            }
        );
    }

    offerAlternateHost() {
        if (Utilities.checkIsLocalHost(location.origin) && Utilities.checkIsLocalHost(this.configurations.baseUrl)) {
        }
    }

    mapLoginErrorMessage(error: string) {
        if (error === 'invalid_username_or_password') {
            return 'Invalid username or password';
        }

        if (error === 'invalid_grant') {
            return 'This account has been disabled';
        }

        return error;
    }

    reset() {
        this.formResetToggle = false;
        setTimeout(() => {
            this.formResetToggle = true;
        });
    }
}
